module.exports = __webpack_public_path__ + "static/media/GTEestiDisplay-Medium.3a90c14e.woff";